export default __webpack_public_path__ + "static/media/add-service.4b81675f.png";